import $ from 'jquery';
import 'bootstrap';
import 'bootstrap/scss/bootstrap.scss';
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import 'ldbutton/dist/ldbtn.css'

import './helpers/prototypes.js'

import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';
import resource from 'vue-resource';

Vue.use(resource);

Vue.config.productionTip = false

global.$ = $;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')